import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";

class EventFieldService {
  getEventFields(event_type) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/etkinliktipialan/get-by-etkinlik-tipi/${event_type}`
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new EventFieldService();
